import styled, { keyframes } from 'styled-components';

const fadeFromTop = keyframes`
  from {
    margin-top: -50px;
    opacity: 0;
  } to {
    margin-top: 0;
    opacity: 1;
  }
`;

export const HeaderContainer = styled.header<{ $smallHeader: boolean }>`
  background-color: ${({ theme }) => theme.baseBlue.a10};
  box-shadow: 0 2px 25px 0 rgba(0, 0, 0, 0.2);
  color: ${({ theme }) => theme.white.a10};
  position: fixed;
  transition: height 30ms;
  width: calc(100% - 60px);
  height: 225px;
  min-height: 60px;
  z-index: 900;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ContentContainer = styled.div`
  width: 100%;
  max-width: ${({ theme }) => theme.sz.pageContentWidth};
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: nowrap;
`;

export const HeaderInner = styled.div<{ $smallHeader: boolean }>`
  width: 100%;
  max-width: ${({ theme }) => theme.sz.pageContentWidth};
  padding: 15px;
`;

export const RightCol = styled.div`
  padding: 15px;
`;

export const HeaderTitle = styled.h1`
  font-weight: 300;
  text-align: left;
  color: ${({ theme }) => theme.white.a10};
`;

export const SubTitle = styled.h2<{ $animate: boolean }>`
  margin-top: 1rem;
  text-align: left;
  color: ${({ theme }) => theme.white.a6};
  animation: ${({ $animate }) => ($animate ? fadeFromTop : 'none')} 200ms ease-in-out;
`;
